export enum ServicesRegister {
  Dictionary = "DictionaryService"
}